export interface BilingualText {
  es: string;
  en: string;
}

export interface Service {
  id: number;
  title: BilingualText;
  shortDesc: BilingualText;
  fullDesc: BilingualText;
  image: string;
  icon: string;
  features: BilingualText[];
  tag: BilingualText | null;
}

export const services: Service[] = [
  {
    id: 1,
    title: { es: 'Limpieza Post-Mudanza', en: 'Move-Out Cleaning' },
    shortDesc: {
      es: 'Deja tu nuevo hogar impecable antes o después de mudarte.',
      en: 'Leave your new home spotless before or after moving.',
    },
    fullDesc: {
      es: 'Nuestro servicio de limpieza post-mudanza garantiza que tu hogar quede completamente limpio. Limpiamos cada rincón, incluyendo inside cabinets, cajones, electrodomésticos, baños, pisos y más. Ideal para inquilinos que se van o propietarios que se mudan.',
      en: 'Our move-out cleaning service guarantees your home is completely clean. We clean every corner, including inside cabinets, drawers, appliances, bathrooms, floors and more. Ideal for tenants moving out or homeowners moving in.',
    },
    image: 'https://public.readdy.ai/ai/img_res/3d24a75c88b6345340b2dc5592832975.jpg',
    icon: 'ri-home-2-line',
    features: [
      { es: 'Limpieza de interior de gabinetes', en: 'Interior cabinet cleaning' },
      { es: 'Limpieza de electrodomésticos', en: 'Appliance cleaning' },
      { es: 'Baños a fondo', en: 'Deep bathroom cleaning' },
      { es: 'Pisos y alfombras', en: 'Floors and carpets' },
      { es: 'Paredes y marcos de puertas', en: 'Walls and door frames' },
    ],
    tag: { es: 'Más Solicitado', en: 'Most Requested' },
  },
  {
    id: 3,
    title: { es: 'Limpieza de Ventanas', en: 'Window Cleaning' },
    shortDesc: {
      es: 'Ventanas cristalinas que dejan entrar toda la luz natural.',
      en: 'Crystal-clear windows that let in all the natural light.',
    },
    fullDesc: {
      es: 'Utilizamos técnicas profesionales y productos especializados para dejar tus ventanas completamente transparentes, sin rayas ni residuos. Atendemos ventanas interiores y exteriores de casas y edificios.',
      en: 'We use professional techniques and specialized products to leave your windows completely clear, streak-free and spotless. We service interior and exterior windows of homes and buildings.',
    },
    image: 'https://readdy.ai/api/search-image?query=professional%20window%20cleaning%20service%20residential%20home%20crystal%20clear%20windows%20professional%20squeegee%20sparkling%20glass%20bright%20sunshine%20modern%20house%20exterior%20professional%20equipment&width=800&height=600&seq=svc003&orientation=landscape',
    icon: 'ri-window-line',
    features: [
      { es: 'Limpieza interior y exterior', en: 'Interior and exterior cleaning' },
      { es: 'Sin rayas ni manchas', en: 'Streak and spot-free' },
      { es: 'Marcos y rieles incluidos', en: 'Frames and tracks included' },
      { es: 'Pantallas y mosquiteros', en: 'Screens and storm windows' },
      { es: 'Puertas de vidrio', en: 'Glass doors' },
    ],
    tag: null,
  },
  {
    id: 4,
    title: { es: 'Lavado a Presión', en: 'Pressure Washing' },
    shortDesc: {
      es: 'Restaura el aspecto de paredes, concreto y superficies exteriores.',
      en: 'Restore the look of walls, concrete and exterior surfaces.',
    },
    fullDesc: {
      es: 'El lavado a presión es la forma más efectiva de limpiar superficies exteriores. Removemos suciedad acumulada, moho, algas y manchas difíciles de paredes, entradas, patios, terrazas y más.',
      en: 'Pressure washing is the most effective way to clean exterior surfaces. We remove built-up dirt, mold, algae, and tough stains from walls, driveways, patios, decks and more.',
    },
    image: 'https://readdy.ai/api/search-image?query=pressure%20washing%20service%20concrete%20driveway%20house%20walls%20high%20pressure%20water%20cleaning%20dirty%20surface%20professional%20equipment%20transformation%20clean%20result%20residential%20property&width=800&height=600&seq=svc004&orientation=landscape',
    icon: 'ri-drop-line',
    features: [
      { es: 'Paredes exteriores', en: 'Exterior walls' },
      { es: 'Entradas y driveways', en: 'Driveways and entries' },
      { es: 'Patios y terrazas', en: 'Patios and decks' },
      { es: 'Cercas y muros', en: 'Fences and walls' },
      { es: 'Superficies de concreto', en: 'Concrete surfaces' },
    ],
    tag: null,
  },
  {
    id: 5,
    title: { es: 'Valet Trash Pick-Up', en: 'Valet Trash Pick-Up' },
    shortDesc: {
      es: 'Servicio de recolección de basura puerta a puerta para condominios.',
      en: 'Door-to-door trash collection service for condominiums.',
    },
    fullDesc: {
      es: 'Ofrecemos el servicio de valet trash para comunidades de condominios y apartamentos. Recolectamos la basura directamente de la puerta de cada unidad en horarios convenientes, manteniendo el edificio limpio y los residentes satisfechos.',
      en: 'We offer valet trash service for condominium and apartment communities. We collect trash directly from each unit\'s door at convenient times, keeping the building clean and residents satisfied.',
    },
    image: 'https://readdy.ai/api/search-image?query=valet%20trash%20service%20worker%20wearing%20bright%20safety%20vest%20collecting%20small%20garbage%20bags%20walking%20apartment%20condominium%20hallway%20corridor%20door%20to%20door%20residential%20building%20indoor%20uniform%20professional%20smiling&width=800&height=600&seq=svc005&orientation=landscape',
    icon: 'ri-delete-bin-line',
    features: [
      { es: 'Recolección puerta a puerta', en: 'Door-to-door collection' },
      { es: 'Horarios flexibles', en: 'Flexible schedules' },
      { es: 'Servicio nocturno disponible', en: 'Nighttime service available' },
      { es: 'Manejo de reciclaje', en: 'Recycling handling' },
      { es: 'Reportes mensuales', en: 'Monthly reports' },
    ],
    tag: { es: 'Para Condominios', en: 'For Condos' },
  },
];
